// Preview runs through the data worker: the UI gets a run summary
//   { version, ok, error: { message, stepId } | null, results, sourceIssues,
//     tables: { [tableId]: { columns, rowCount } }, scope, hasSample(id) }
// and asks for rows with dataHost.getRows when it shows a table.
import { logTimings, ms, now } from "../shared/perfLog";
import { dataHost } from "./dataHost";

// The worker's view of the sample files: { [sourceId]: { key, sheetName, columnOverrides } }.
export const fileRefsOf = (files) =>
  Object.fromEntries(Object.entries(files).map(([id, file]) => [id, { key: file.key, sheetName: file.sheetName, columnOverrides: file.columnOverrides }]));

// Runs the workflow's code steps on the sample files. `scope` keeps results
// apart ("editor" for the trail, "draft" for an AI proposal); `trigger` only
// labels the dev timing log. Resolves with { stale: true } when a newer run
// of the same scope replaced this one before it started.
export const previewRun = async (workflow, files, { scope = "editor", trigger = "editor" } = {}) => {
  const start = now();
  const run = await dataHost.preview(scope, workflow, fileRefsOf(files));
  if (run.stale) return run;
  const stepMs = run.results.reduce((sum, r) => sum + (r.durationMs || 0), 0);
  logTimings("preview", start, {
    trigger,
    sources: Object.keys(files).map((id) => ({ rows: run.tables[id]?.rowCount, columns: run.tables[id]?.columns.length })),
    bindMs: ms(run.timings.bindMs),
    workerMs: ms(run.timings.totalMs),
    stepsMs: ms(stepMs),
    ok: run.ok,
    steps: run.results.map((r) => ({ id: r.stepId, label: workflow.steps.find((s) => s.id === r.stepId)?.label, status: r.status, rowsIn: r.rowsIn, rowsOut: r.rowsOut, ms: ms(r.durationMs || 0) })),
  });
  return { ...run, scope, hasSample: (id) => Boolean(files[id]) };
};
